module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/contracts/weapiEventPayload.ts":
/***/ (function(module, exports) {



/***/ }),

/***/ "./src/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "@babel/runtime/helpers/asyncToGenerator"
var asyncToGenerator_ = __webpack_require__("@babel/runtime/helpers/asyncToGenerator");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_);

// EXTERNAL MODULE: external "@babel/runtime/regenerator"
var regenerator_ = __webpack_require__("@babel/runtime/regenerator");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator_);

// EXTERNAL MODULE: external "web-vitals/base"
var base_ = __webpack_require__("web-vitals/base");

// CONCATENATED MODULE: ./src/metrics/onCumulativeLayoutShift.js


var onCumulativeLayoutShift_onCumulativeLayoutShift = function onCumulativeLayoutShift(response) {
  Object(base_["getCLS"])(function (cls) {
    return response(cls.value);
  });
};

/* harmony default export */ var metrics_onCumulativeLayoutShift = (onCumulativeLayoutShift_onCumulativeLayoutShift);
// CONCATENATED MODULE: ./src/defer.js
function defer() {
  var deferred = {
    promise: null,
    resolve: null,
    reject: null
  };
  deferred.promise = new Promise(function (resolve, reject) {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
}

/* harmony default export */ var src_defer = (defer);
// CONCATENATED MODULE: ./src/metrics/performanceListener.js

var domCompletePromise = src_defer();
var domInteractivePromise = src_defer();
var domLoadingPromise = src_defer();
var windowOnLoadPromise = src_defer();

function checkEntries(entries) {
  entries.forEach(function (entry) {
    if (entry.domComplete) {
      domCompletePromise.resolve(entry.domComplete - entry.domContentLoadedEventEnd);
    }

    if (entry.domContentLoadedEventStart) {
      domInteractivePromise.resolve(entry.domContentLoadedEventStart - entry.domInteractive);
    }

    if (entry.domInteractive) {
      domLoadingPromise.resolve(entry.domInteractive - entry.unloadEventEnd);
    }

    if (entry.loadEventEnd) {
      windowOnLoadPromise.resolve(entry.loadEventEnd - entry.loadEventStart);
    }
  });
}

if (typeof window !== 'undefined') {
  if ('performance' in window) {
    if ('PerformanceObserver' in window) {
      var perfObserver = new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        checkEntries(entries);
      });
      perfObserver.observe({
        entryTypes: ['navigation']
      });
    } else if (window.onload) {
      window.onload(function () {
        var entries = performance.getEntriesByType('navigation');
        checkEntries(entries);
      });
    }
  }
}

var getDomComplete = function getDomComplete() {
  return domCompletePromise.promise;
};

var getDomInteractive = function getDomInteractive() {
  return domInteractivePromise.promise;
};

var getDomLoading = function getDomLoading() {
  return domLoadingPromise.promise;
};

var getWindowLoad = function getWindowLoad() {
  return windowOnLoadPromise.promise;
};


// CONCATENATED MODULE: ./src/metrics/onDomComplete.js


var onDomComplete_onDomComplete = function onDomComplete(response) {
  getDomComplete().then(function (domComplete) {
    return response(domComplete);
  });
};

/* harmony default export */ var metrics_onDomComplete = (onDomComplete_onDomComplete);
// CONCATENATED MODULE: ./src/metrics/onDomInteractive.js


var onDomInteractive_onDomInteractive = function onDomInteractive(response) {
  getDomInteractive().then(function (domInteractive) {
    return response(domInteractive);
  });
};

/* harmony default export */ var metrics_onDomInteractive = (onDomInteractive_onDomInteractive);
// CONCATENATED MODULE: ./src/metrics/onDomLoading.js


var onDomLoading_onDomLoading = function onDomLoading(response) {
  getDomLoading().then(function (domLoading) {
    return response(domLoading);
  });
};

/* harmony default export */ var metrics_onDomLoading = (onDomLoading_onDomLoading);
// CONCATENATED MODULE: ./src/metrics/onFirstContentfulPaint.js


var onFirstContentfulPaint_onFirstContentfulPaint = function onFirstContentfulPaint(response) {
  Object(base_["getFCP"])(function (fcp) {
    return response(fcp.value);
  });
};

/* harmony default export */ var metrics_onFirstContentfulPaint = (onFirstContentfulPaint_onFirstContentfulPaint);
// CONCATENATED MODULE: ./src/metrics/onFirstInputDelay.js


var onFirstInputDelay_onFirstInputDelay = function onFirstInputDelay(response) {
  Object(base_["getFID"])(function (fid) {
    return response(fid.value);
  });
};

/* harmony default export */ var metrics_onFirstInputDelay = (onFirstInputDelay_onFirstInputDelay);
// CONCATENATED MODULE: ./src/metrics/onLargestContentfulPaint.js


var onLargestContentfulPaint_onLargestContentfulPaint = function onLargestContentfulPaint(response) {
  Object(base_["getLCP"])(function (lcp) {
    return response(lcp.value);
  });
};

/* harmony default export */ var metrics_onLargestContentfulPaint = (onLargestContentfulPaint_onLargestContentfulPaint);
// CONCATENATED MODULE: ./src/metrics/onTimeToFirstByte.js


var onTimeToFirstByte_onTimeToFirstByte = function onTimeToFirstByte(response) {
  Object(base_["getTTFB"])(function (ttfb) {
    return response(ttfb.value);
  });
};

/* harmony default export */ var metrics_onTimeToFirstByte = (onTimeToFirstByte_onTimeToFirstByte);
// CONCATENATED MODULE: ./src/metrics/onWindowOnLoad.js


var onWindowOnLoad_onWindowOnLoad = function onWindowOnLoad(response) {
  getWindowLoad().then(function (windowLoad) {
    return response(windowLoad);
  });
};

/* harmony default export */ var metrics_onWindowOnLoad = (onWindowOnLoad_onWindowOnLoad);
// CONCATENATED MODULE: ./src/metrics/getBenchmark.js
 // https://github.com/GoogleChrome/lighthouse/blob/925cb1d6a489178ee20d5727a586508dbd070245/lighthouse-core/lib/page-functions.js#L189

function benchmarkIndexGC() {
  var start = Date.now();
  var iterations = 0;

  while (Date.now() - start < 250) {
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    var s = '';

    for (var j = 0; j < 10000; j++) {
      s += 'a';
    }

    iterations++;
  }

  var durationInSeconds = (Date.now() - start) / 1000;
  return Math.round(iterations / 10 / durationInSeconds);
} // https://github.com/GoogleChrome/lighthouse/blob/925cb1d6a489178ee20d5727a586508dbd070245/lighthouse-core/lib/page-functions.js#L209


function benchmarkIndexNoGC() {
  var arrA = [];
  var arrB = []; // eslint-disable-next-line no-multi-assign

  for (var i = 0; i < 100000; i++) {
    arrA[i] = arrB[i] = i;
  }

  var start = Date.now();
  var iterations = 0;

  while (iterations % 10 !== 0 || Date.now() - start < 250) {
    var src = iterations % 2 === 0 ? arrA : arrB;
    var tgt = iterations % 2 === 0 ? arrB : arrA;

    for (var j = 0; j < src.length; j++) {
      tgt[j] = src[j];
    }

    iterations++;
  }

  var durationInSeconds = (Date.now() - start) / 1000;
  return Math.round(iterations / 10 / durationInSeconds);
}

function benchmark() {
  return 0; // return (benchmarkIndexGC() + benchmarkIndexNoGC()) / 2;
}

var benchmarkPromise = src_defer();

if (typeof document !== 'undefined') {
  document.addEventListener('DOMContentLoaded', function () {
    benchmarkPromise.resolve(benchmark());
  });
}

var getBenchmark = function getBenchmark() {
  return benchmarkPromise.promise;
};

/* harmony default export */ var metrics_getBenchmark = (getBenchmark);
// CONCATENATED MODULE: ./src/metrics/onBenchmark.js


var onBenchmark_onBenchmark = function onBenchmark(response) {
  metrics_getBenchmark().then(function (value) {
    return response(value);
  });
};

/* harmony default export */ var metrics_onBenchmark = (onBenchmark_onBenchmark);
// CONCATENATED MODULE: ./src/metrics/index.js











var metrics_reportMetrics = function reportMetrics(report) {
  var fullResponse = function fullResponse(name, unit) {
    return function (value) {
      return report(name, value, unit);
    };
  };

  metrics_onCumulativeLayoutShift(fullResponse('cumulative-layout-shift', ''));
  metrics_onDomComplete(fullResponse('dom-complete', 'ms'));
  metrics_onDomInteractive(fullResponse('dom-interactive', 'ms'));
  metrics_onDomLoading(fullResponse('dom-loading', 'ms'));
  metrics_onFirstContentfulPaint(fullResponse('first-contentful-paint', 'ms'));
  metrics_onFirstInputDelay(fullResponse('first-input-delay', 'ms'));
  metrics_onLargestContentfulPaint(fullResponse('largest-contentful-paint', 'ms'));
  metrics_onTimeToFirstByte(fullResponse('time-to-first-byte', 'ms'));
  metrics_onWindowOnLoad(fullResponse('window-on-load', 'ms'));
  metrics_onBenchmark(fullResponse('cpu-benchmark', 'ops'));
};

/* harmony default export */ var metrics = (metrics_reportMetrics);
// EXTERNAL MODULE: external "uuid"
var external_uuid_ = __webpack_require__("uuid");

// CONCATENATED MODULE: ./src/getCookie.ts
/* eslint-disable no-useless-escape */
var getCookie = function getCookie(name) {
  function escape(s) {
    return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1');
  }

  var match = document.cookie.match(RegExp("(?:^|;\\s*)" + escape(name) + "=([^;]*)"));
  return match ? match[1] : null;
};

/* harmony default export */ var src_getCookie = (getCookie);
// CONCATENATED MODULE: ./src/envelope/getBrowserCookieId.ts


var getBrowserCookieId_getBrowserCookieId = function getBrowserCookieId() {
  return src_getCookie('BrowserCookieId');
};

/* harmony default export */ var envelope_getBrowserCookieId = (getBrowserCookieId_getBrowserCookieId);
// EXTERNAL MODULE: external "jwt-decode"
var external_jwt_decode_ = __webpack_require__("jwt-decode");
var external_jwt_decode_default = /*#__PURE__*/__webpack_require__.n(external_jwt_decode_);

// CONCATENATED MODULE: ./src/envelope/getCarvanaUserId.ts



var getCarvanaUserId_getCarvanaUserId = function getCarvanaUserId() {
  try {
    var cvIdToken = src_getCookie('CVIdToken');
    var decodedToken = external_jwt_decode_default()(cvIdToken) || {};
    return decodedToken.sub;
  } catch (e) {
    return undefined;
  }
};

/* harmony default export */ var envelope_getCarvanaUserId = (getCarvanaUserId_getCarvanaUserId);
// CONCATENATED MODULE: ./src/envelope/correlationId.ts

var correlationId_correlationId = Object(external_uuid_["v4"])();
/* harmony default export */ var envelope_correlationId = (correlationId_correlationId);
// CONCATENATED MODULE: ./src/envelope/getCurrentRoute.ts
var getCurrentRoute = function getCurrentRoute() {
  return window.location.href;
};

/* harmony default export */ var envelope_getCurrentRoute = (getCurrentRoute);
// CONCATENATED MODULE: ./src/envelope/getReferralUrl.ts
var getReferralUrl = function getReferralUrl() {
  return document.referrer;
};

/* harmony default export */ var envelope_getReferralUrl = (getReferralUrl);
// CONCATENATED MODULE: ./src/envelope/getBrowserResolution.ts
var getBrowserResolution = function getBrowserResolution() {
  return window.innerWidth + "x" + window.innerHeight;
};

/* harmony default export */ var envelope_getBrowserResolution = (getBrowserResolution);
// CONCATENATED MODULE: ./src/envelope/getScreenResolution.ts
/* eslint-disable no-restricted-globals */
var getScreenResolution = function getScreenResolution() {
  return screen.width + "x" + screen.height;
};

/* harmony default export */ var envelope_getScreenResolution = (getScreenResolution);
// CONCATENATED MODULE: ./src/envelope/getUserAgent.ts
var getUserAgent = function getUserAgent() {
  return window.navigator.userAgent;
};

/* harmony default export */ var envelope_getUserAgent = (getUserAgent);
// CONCATENATED MODULE: ./src/envelope/index.ts












var getEnvelope = /*#__PURE__*/function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(environment, project, track, eventName, correlationIdOverride) {
    var carvanaUserId;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return envelope_getCarvanaUserId();

          case 2:
            carvanaUserId = _context.sent;
            _context.t0 = Object;
            _context.t1 = {};
            _context.t2 = carvanaUserId && {
              carvanaUser: {
                id: carvanaUserId
              }
            };
            _context.next = 8;
            return envelope_getBrowserCookieId();

          case 8:
            _context.t3 = _context.sent;
            _context.next = 11;
            return envelope_getBrowserResolution();

          case 11:
            _context.t4 = _context.sent;
            _context.next = 14;
            return envelope_getReferralUrl();

          case 14:
            _context.t5 = _context.sent;
            _context.next = 17;
            return envelope_getCurrentRoute();

          case 17:
            _context.t6 = _context.sent;
            _context.next = 20;
            return envelope_getUserAgent();

          case 20:
            _context.t7 = _context.sent;
            _context.t8 = {
              cookieId: _context.t3,
              resolution: _context.t4,
              referralUrl: _context.t5,
              url: _context.t6,
              userAgent: _context.t7
            };
            _context.next = 24;
            return envelope_getScreenResolution();

          case 24:
            _context.t9 = _context.sent;
            _context.t10 = {
              resolution: _context.t9
            };
            _context.t11 = {
              browser: _context.t8,
              device: _context.t10
            };
            _context.t12 = _context.t0.assign.call(_context.t0, _context.t1, _context.t2, _context.t11);
            _context.t13 = {
              id: Object(external_uuid_["v4"])(),
              name: eventName,
              timestamp: new Date()
            };
            _context.t14 = {
              correlationId: correlationIdOverride || envelope_correlationId,
              environment: environment,
              project: project,
              track: track
            };
            return _context.abrupt("return", {
              clickstream: _context.t12,
              event: _context.t13,
              metadata: _context.t14
            });

          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getEnvelope(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ var src_envelope = (getEnvelope);
// CONCATENATED MODULE: ./src/constructData.ts
var constructData = function constructData(envelope, data) {
  return Object.assign({}, envelope, {
    customAttributes: Object.assign({}, data)
  });
};

/* harmony default export */ var src_constructData = (constructData);
// CONCATENATED MODULE: ./src/sendData.ts
var sendData = function sendData(url, payload) {
  var headers = {
    // Hack for sendBeacon to work. Should be 'application/json'.
    type: 'text/plain'
  };
  var data = {
    query: "mutation weapiEvent($EventPayload: EventPayload!) { event( payload: $EventPayload ) }",
    operationName: 'weapiEvent',
    variables: {
      EventPayload: payload
    }
  };

  if (navigator.sendBeacon) {
    var blob = new Blob([JSON.stringify(data)], headers); // Note: this will return a 400 if any of the required fields aren't present, such as BCID or Carvana user ID.

    navigator.sendBeacon(url, blob);
  } else {
    fetch(url, {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(data),
      keepalive: true
    }).then(function (response) {
      console.log('Performance event sent successfully', response.text);
    }).catch(function (error) {
      throw Error("Error: " + error);
    });
  }
};

/* harmony default export */ var src_sendData = (sendData);
// CONCATENATED MODULE: ./src/constants/index.ts
var prodUrl = 'https://analytics.carvana.io/edge/web-eventable/api/graph';
var devUrl = 'https://analytics.zagforward.com/edge/web-eventable/api/graph';
var testUrl = 'https://analytics.carvanatech.com/edge/web-eventable/api/graph';
// CONCATENATED MODULE: ./src/trackPerformance.ts








var getDataFromMetrics = function getDataFromMetrics(name, value, unit, payloadMetaAttributes) {
  return {
    customAttributes: Object.assign({
      name: name,
      value: value,
      unit: unit
    }, payloadMetaAttributes)
  };
};

var ANALYTICS_ENDPOINT = {
  production: prodUrl,
  prod: prodUrl,
  development: devUrl,
  dev: devUrl,
  test: testUrl
}; // Prevent function from being called more than once per session.

var trackPerformanceExecuted = false;

var trackPerformance_trackPerformance = function trackPerformance(_ref) {
  var environment = _ref.environment,
      project = _ref.project,
      track = _ref.track,
      _ref$customEventName = _ref.customEventName,
      customEventName = _ref$customEventName === void 0 ? '' : _ref$customEventName,
      _ref$payloadMetaAttri = _ref.payloadMetaAttributes,
      payloadMetaAttributes = _ref$payloadMetaAttri === void 0 ? {} : _ref$payloadMetaAttri,
      _ref$correlationId = _ref.correlationId,
      correlationId = _ref$correlationId === void 0 ? '' : _ref$correlationId;

  if (trackPerformanceExecuted) {
    console.log('trackPerformance() already called. This method should only be called once.');
    return null;
  }

  trackPerformanceExecuted = true;

  if (!environment || !project || !track) {
    throw Error('params environment, project, and track are required for trackPerformance()');
  }

  var endpoint = ANALYTICS_ENDPOINT[environment] || ANALYTICS_ENDPOINT.dev;
  var eventName = customEventName || 'performance';

  var trackData = /*#__PURE__*/function () {
    var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(data) {
      var _ref3, _ref3$customAttribute, customAttributes, webVitalEventName, envelope, fullData;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref3 = data || {}, _ref3$customAttribute = _ref3.customAttributes, customAttributes = _ref3$customAttribute === void 0 ? {} : _ref3$customAttribute;
              webVitalEventName = customAttributes.name;
              _context.next = 4;
              return src_envelope(environment, project, track, eventName, correlationId);

            case 4:
              envelope = _context.sent;
              fullData = src_constructData(envelope, customAttributes); // Add eventName as a query param so it's easier to find in Chrome dev tools.

              src_sendData(endpoint + "?" + webVitalEventName, fullData);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function trackData(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof window !== 'undefined') {
    metrics(function (name, value, unit) {
      return trackData(getDataFromMetrics(name, value, unit, payloadMetaAttributes));
    });
  }
};

/* harmony default export */ var src_trackPerformance = (trackPerformance_trackPerformance);
// EXTERNAL MODULE: ./src/contracts/weapiEventPayload.ts
var weapiEventPayload = __webpack_require__("./src/contracts/weapiEventPayload.ts");
var weapiEventPayload_default = /*#__PURE__*/__webpack_require__.n(weapiEventPayload);

// CONCATENATED MODULE: ./src/index.ts
/* concated harmony reexport default */__webpack_require__.d(__webpack_exports__, "default", function() { return src_trackPerformance; });
/* concated harmony reexport WeapiEventPayload */__webpack_require__.d(__webpack_exports__, "WeapiEventPayload", function() { return weapiEventPayload_default.a; });




/***/ }),

/***/ "@babel/runtime/helpers/asyncToGenerator":
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),

/***/ "@babel/runtime/regenerator":
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/regenerator");

/***/ }),

/***/ "jwt-decode":
/***/ (function(module, exports) {

module.exports = require("jwt-decode");

/***/ }),

/***/ "uuid":
/***/ (function(module, exports) {

module.exports = require("uuid");

/***/ }),

/***/ "web-vitals/base":
/***/ (function(module, exports) {

module.exports = require("web-vitals/base");

/***/ })

/******/ });
//# sourceMappingURL=index.js.map